export const TIcketInformationSection = ({ ticket }) => {
    return (
        <div className="space-y-4">
            <div>
                <p className="text-xs font-medium text-slate-500 mb-1 uppercase tracking-wider">Judul</p>
                <p className="text-slate-200 font-semibold">{ticket?.title}</p>
            </div>
            <div>
                <p className="text-xs font-medium text-slate-500 mb-1 uppercase tracking-wider">Deskripsi</p>
                <p className="text-slate-400 text-sm leading-relaxed">{ticket?.description}</p>
            </div>
            <div>
                <p className="text-xs font-medium text-slate-500 mb-1 uppercase tracking-wider">Catatan Admin</p>
                <p className="text-slate-400 text-sm leading-relaxed italic">{ticket?.note || "-"}</p>
            </div>
        </div>
    )
}